<template>
    <div class="newly-updated-daily" ref="latestDetailWrapper" v-if="ajaxDone">
        <div>
            <div class="daily-head">
                <h3 class="daily-head-title" v-if="LatestName">{{LatestName}}</h3>
                <div class="analyse-info">
                    <span>{{ LatestViewTotal | validCount }}人浏览</span>
                </div>
            </div>

            <div class='daily-content' v-for="(item,index) in LatestList" :key="index">
                <div class='daily-content-head'>{{ item.Depart }}</div>
                <div class="daily-content-container" v-for="v in item.List">
                    <div class='daily-content-card' @click="viewDetail(v.KBTypeId, v.KBInfoId,v)">
                        <div class="daily-tag-box">
                            <div class='daily-tag' :class="{'daily-tag-edit': tag === '修改', 'daily-tag-deleted': tag === '删除'}" v-for="(tag,i) in v.tagList" v-text="tag"></div>
                        </div>
                        <div class='daily-card-content'>{{ v.Title }}</div>
                    </div>
                    <div class='daily-remark' v-html='v.Content'></div>
                </div>
            </div>

            <div class="more-daily-text" @click="$router.push({ path: '/recentDailyReport' })" v-if="linkShow">更多近期知识日报</div>

            <!-- 无权限页面 -->
            <unauthorize v-if="callUnauthorize" :unauthorizeType="unauthorizeType"></unauthorize>

            <!-- 水印 -->
            <water-mark ref="watermark"></water-mark>
        </div>
    </div>
</template>

<script>
    let latestDetailPageOrigin;
    import { HOME,COMMON } from '@/api'
    import waterMark from '../components/waterMark'
    import unauthorize from './404/403.vue'
    export default {
        name: 'latestDetail',
        components: {
            unauthorize,waterMark
        },
        data () {
            return {
                LogId: '',
                ajaxDone: false,
                uuId: this.$route.params.uuid.split('&')[0],
                LatestList: [],
                LatestName: '',
                LatestViewTotal: '-',
                unauthorizeType: '',
                callUnauthorize: false,
                linkShow: true  // 是否展示按钮
            }
        },
        mounted () {
            this.GetLatestDetail();
            this.SetRead();
        },
        methods: {
            // 转换日报的具体数据（p标签或者div标签的添加新增样式）
            mapData(data) {
                if(data.length>0){
                    data.map((value,item)=>{
                        if(value.List&&value.List.length>0){
                            this.mapData(value.List);
                        }else{
                            if(value.Content&&value.Content.length>0){
                                if(value.Content.slice(0,3)=="<p>"){
                                    value.Content="<p>"+'<span class="item-contain-tag" >'+value.Adjustway+'</span>'+value.Content.slice(3,value.Content.length);
                                }else if(value.Content.slice(0,5)=="<div>"){
                                    value.Content="<div>"+'<span class="item-contain-tag" >'+value.Adjustway+'</span>'+value.Content.slice(5,value.Content.length);
                                }else{
                                    value.Content='<span class="item-contain-tag" >'+value.Adjustway+'</span>'+value.Content;
                                }
                            }
                        }
                    })
                }
            },
            GetLatestDetail() {

                // 埋点数据
                COMMON.DailyUpdateReport({
                    ReleaseId: this.uuId,
                    Refer: latestDetailPageOrigin ? 'Mainpage' : 'Notice'
                }).then( (res) => {
                    this.LogId = res.Data.LogId
                })


                // 获取最新更新详情
                HOME.GetLatestDetail({ReleaseId: this.uuId}).then( (res) => {
                    this.ajaxDone = true;
                    if(res.Code == 200 && res.Data && !!res.Data.Name) {
                        //处理tag标签
                        if(res.Data.List&&res.Data.List.length>0){
                            res.Data.List.map((value,key)=>{
                                if(value.List&&value.List.length>0){
                                    value.List.map((v,k)=>{
                                        v.tagList=v.Adjustway.split(',');
                                    })
                                }

                            })
                        }
                        this.LatestList = res.Data.List;
                        this.linkShow = res.Data.HasPush

                        // 生成最新更新详情页的水印
                        setTimeout( () => {  // 彻底关闭之后重新绘画
                            this.$refs.watermark && this.$refs.watermark.initWaterMark()
                        }, 300)
                        this.LatestName = res.Data.Name;
                        this.LatestViewTotal = res.Data.TotalViewCount;
                    }else{
                        this.unauthorizeType = '401'
                        this.callUnauthorize = true
                    }
                }).catch((error)=>{
                    this.ajaxDone = true;
                })
            },
            SetRead() {  // 设置最新详情已读
                HOME.SetRead({ReleaseId: this.uuId}).then( (res) => {
                    if(res.Code==200){
                        //设置已读成功将new去掉
                        // this.$store.commit('NEWDAILY',false)
                    }
                })
            },
            viewDetail(KBTypeId, KBInfoId,KB) {
                // 埋点数据
                COMMON.UpdateDailyReportViewData({
                    LogId: this.LogId,
                    KBInfoId: KB.KBInfoId,
                    KBName: KB.Title
                }).then((res)=>{
                    // ...
                    // console.log('日报发布时间', '还没有字段，待定')
                    // console.log('日报名称', this.LatestName)
                    // console.log('域账号', localStorage.ADAccount)
                    // console.log('点击时间', +new Date())
                    // ...
                })

                if(KBTypeId === 1){  // 跳知识详情
                    this.$router.push({ name: 'knowledge', params: { uuid: KBInfoId } })
                } else {  // 跳常见问题详情
                    this.$router.push({ name: 'faq', params: { uuid: KBInfoId } })
                }
            }
        },
        beforeRouteEnter(to,from,next){
            latestDetailPageOrigin = from.name
            next()
        },
        beforeRouteLeave (to, from, next) {
            this.callUnauthorize=false;
            localStorage.setItem('latestDetailScrollTop',this.$refs.latestDetailWrapper.scrollTop)
            next();
        },
        watch: {
            '$route' (to, from) {  // 监听日报详情页面
                if(to.name == "latestDetail" && this.uuId != this.$route.params.uuid.split('&')[0]) {
                    this.LatestList = [];
                    this.LatestName = '';
                    this.ajaxDone = false;
                    this.uuId = this.$route.params.uuid.split('&')[0];
                    this.GetLatestDetail();
                    this.SetRead();
                }

                if(to.name == "latestDetail" && this.uuId == this.$route.params.uuid.split('&')[0]){
                    this.$refs.latestDetailWrapper.scrollTop = localStorage.latestDetailScrollTop
                }
                // if(from.name == "knowledge") {
                //     // this.GetLatestDetail();
                //     // this.SetRead();
                // }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .newly-updated-daily {
        height: 100%;
        overflow-y:scroll;
        padding-bottom: j(100);
        color: #363C54;
        box-sizing: border-box;
        & > div {
            min-height: 100%;
            position: relative;
        }
        .daily-head {
            padding:j(50);
            background:#fff;

            .daily-head-title {
                width:100%;
                line-height:j(67);
                font-size:j(48);
                color:#363C54;
                font-weight:500;
            }
            .analyse-info {
                margin-top: j(20);
                font-size: j(24);
                color: #9B9DA9;
            }
        }

        .daily-content {
            padding:j(50);
            border-top:j(20) solid #F7F8FA;
            box-sizing: border-box;

            & > .daily-content-container+.daily-content-container{
                margin-top:j(100);
            }

            .daily-content-head{
                line-height:j(45);
                font-size:j(32);
                font-weight:500;
                color:#363C54;
                word-break: break-word;
            }

            .daily-content-container{

                .daily-content-card{
                    padding:j(30) j(30) j(40);
                    box-shadow:0px j(5) j(20) 0px rgba(0,0,0,0.07);
                    border-radius: j(2);
                    margin:j(30) 0;
                    box-sizing: border-box;

                    .daily-tag-box{
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        // border:1px solid red;
                    }

                    .daily-tag{
                        border-radius:0 j(15);
                        font-size:j(20);
                        font-weight:400;
                        color:#004B64;
                        background:#B8E8EB;
                        padding:j(4) j(20);
                        display: flex;
                        align-items: center;
                        box-sizing: border-box;
                        margin-right:j(20);
                    }
                    .daily-tag-edit{
                        color:#fff!important;
                        background:#004B64!important;
                    }
                    .daily-tag-deleted{
                        color:#fff!important;
                        background:#CDCED4!important;
                    }

                    .daily-card-content{
                        font-size:j(34);
                        color:#363C54;
                        line-height:j(48);
                        font-weight:500;
                        margin-top:j(20);
                        word-break:break-word;
                    }

                }
                .daily-remark{
                    width: 100%;
                    font-size: j(30);
                    font-weight: 300;
                    color:#696D7F;
                    line-height:j(40);
                    word-break:break-word;
                    margin:0 auto;
                    box-sizing: border-box;

                    // .item-contain-tag {
                    //     padding: 1px j(15);
                    //     margin-right: j(10);
                    //     height: j(20);
                    //     line-height: j(20);
                    //     border-radius: j(20);
                    //     font-size: 12px;
                    //     color: #fff;
                    //     background: #00BCBC;
                    // }
                }

            }


        }

        .more-daily-text {
            width: j(336);
            padding: j(22) 0;
            margin: j(50) auto;
            text-align: center;
            font-size: j(32);
            color: #696d7f;
            border: 1px solid #f0f1f2;
            border-radius: j(45);
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/latestDetail.vue